import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "src/environments/environment.prod";

@Injectable({
    providedIn: "root",
})
export class AccountSettingService {
    googleAnalaticsUserData: any = {};

    constructor(private http: HttpClient) {}

    /// ======= edit guest profile  ======= ///
    editGuestProfile(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/full-edit`,
            data
        );
    }
    /// ======= edit profile  ======= ///
    editProfile(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/edit`,
            data
        );
    }
    /// ======= verify email  ======= ///
    verifyEmail(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/verify/email`,
            data
        );
    }
    /// ======= edit change passowrd  ======= ///
    changePassword(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/change_password`,
            data
        );
    }

    /// ======= edit address  ======= ///
    editAddress(data: any, id: number) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/addresses/` + id,
            data
        );
    }
    /// ======= add address  ======= ///
    addAddress(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/addresses`,
            data
        );
    }
    /// ======= delete address  ======= ///
    deleteAddress(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/addresses/remove/${data.id}`,
            data
        );
    }
    /// ======= get  orders  ======= ///

    getOrders(data: any) {
        return this.http.get<any>(
            `${environment.api}/api/customer/orders?page=${data.page}&phone=${
                data.phone ? data.phone : ""
            }`
        );
    }
    /// ======= send verificaton  message  ======= ///
    sendVerficationMessage(data?: null) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/phone-verify`,
            data
        );
    }
    /// ======= cancel  orders  ======= ///
    cancelOrders(id: number, data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/orders/cancel/` + id,
            data
        );
    }

    getOrderById(id: number) {
        return this.http.get<any>(
            `${environment.api}/api/customer/orders/` + id
        );
    }
    getReasons() {
        return this.http.get<any>(
            `${environment.api}/api/customer/order_cancellation_reasons`
        );
    }
    getCities() {
        return this.http.get<any>(`${environment.api}/api/cities`);
    }
  

    UpdateInvintoryArea(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/profile/set_area
`,
            data
        );
    }

    createBankAccount(data:any){
         return this.http.post<any>(
            `${environment.api}/api/customer/profile/edit_bank_info` ,
            data
        );
    }


    Checkarea(coordnatesObj:any , add_address?:any){
        add_address ==  false ? add_address =  '' : add_address =  true
        return this.http.get<any>(`${environment.api}/api/customer/profile/check-area?lng=${coordnatesObj.lng_marker}&lat=${coordnatesObj.lat_marker}&add_address=${add_address}`);
    }

      getAreas(add_address?:any) {
          add_address ==  false ? add_address =  '' : add_address =  true
          return this.http.get<any>(`${environment.api}/api/customer/profile/area-maps?add_address=${add_address}`
          );
      }

        getAvailableCities() {
        return this.http.get<any>(`${environment.api}/api/customer/profile/areas`);
    }
}
